import { render, staticRenderFns } from "./modal-two-horizontal-btn2.mpx?vue&type=template&id=e4054636&isComponent&outputPath=components%2Fmodal-two-horizontal-btn21e2f7dc7%2Findex"
import script from "./modal-two-horizontal-btn2.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-two-horizontal-btn21e2f7dc7%2Findex"
export * from "./modal-two-horizontal-btn2.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-two-horizontal-btn21e2f7dc7%2Findex"
import style0 from "./modal-two-horizontal-btn2.mpx?vue&type=style&index=0&id=e4054636&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_1e2f7dc7%22%7D&isComponent&outputPath=components%2Fmodal-two-horizontal-btn21e2f7dc7%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports